import { type ComponentProps } from "react";
import {
  ErrorText,
  FieldTitle,
  FormGrid,
  HintText,
  InputField,
  LinkButton,
  PolicyLink,
  PolicyText,
  PrimaryButton,
  TwoCol,
  WarnText,
} from "../styles";

type CustomerFormSectionProps = {
  onSubmit: ComponentProps<"form">["onSubmit"];
  onBack: () => void;
  isSubmitting: boolean;
  errorMessage?: string;
};

export default function CustomerFormSection({
  onSubmit,
  onBack,
  isSubmitting,
  errorMessage,
}: CustomerFormSectionProps) {
  return (
    <FormGrid onSubmit={onSubmit}>
      <label>
        <FieldTitle>
          <i>必須</i> お名前
        </FieldTitle>
        <TwoCol>
          <InputField id="lastName" name="lastName" type="text" placeholder="姓" required />
          <InputField id="firstName" name="firstName" type="text" placeholder="名" required />
        </TwoCol>
      </label>

      <label>
        <FieldTitle>
          <i>必須</i> 電話番号
        </FieldTitle>
        <WarnText>
          弊社コンシェルジュが査定に必要な情報をまとめるため、一度だけお電話させていただきます。
          <br />
          ※不動産会社からの営業電話は一切ありません。
        </WarnText>
        <InputField id="phone" name="phone" type="tel" placeholder="09012345678（ハイフン不要）" required />
      </label>

      <label>
        <FieldTitle>
          <i>必須</i> メールアドレス
        </FieldTitle>
        <HintText>査定結果をお送りさせていただく際に利用します。</HintText>
        <InputField id="email" name="email" type="email" placeholder="sample@mail.com" required />
      </label>

      <PolicyText>
        <PolicyLink
          href="https://propally.co.jp/legal/privacypolicy/"
          target="_blank"
          rel="noreferrer"
        >
          プライバシーポリシー
        </PolicyLink>
        に同意の上ご利用ください。
      </PolicyText>

      {errorMessage ? <ErrorText>{errorMessage}</ErrorText> : null}

      <PrimaryButton id="smaul-submit-btn" type="submit" disabled={isSubmitting}>
        {isSubmitting ? "送信中..." : "同意して送信する"}
      </PrimaryButton>
      <LinkButton type="button" onClick={onBack} disabled={isSubmitting}>
        戻る
      </LinkButton>
    </FormGrid>
  );
}
